import React from "react";


const TanjiIcon: React.FC<{ h?: number }> = ({h = 34}) => <svg width={h} viewBox="0 0 34 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.1107 29.4319L23.0952 32.3045L18.0796 35.1771V23.683L23.0952 26.5556L28.1107 29.4282V23.6822L23.2132 20.8754L18.0796 17.9332V6.43528L13.0633 3.56268V15.0591L8.04777 12.1865L3.03223 15.0591L8.11403 17.9718L13.0641 20.8073V26.5571V38.0528L18.0804 40.9254L23.0959 38.0528L28.1115 35.1802L28.1107 29.4319Z" fill="white"/>
  </svg>;

export {TanjiIcon};